import React, { useState } from "react";
// import { Modal } from "antd"; 
import FeatherIcon from "feather-icons-react";

import { Button } from "../../../../components/buttons/buttons";
import { Modal } from "antd";
import { Form } from "../ProprietarioForm";
import { useFetch } from "../../../../hooks/useFetch";

interface ITableButtonEditProps {
  proprietarioId: string;
  refetch: () => void;
  data: IFetchProps;
}

interface IFetchProps {
  bancoAgencia: string;
  comprovanteResidencia: string;
  idPessoa: string;
  bancoConta: string;
  idEmpresa: string;
  idBanco: string;
  
}

export function TableButtonEdit({ proprietarioId, refetch, data }: ITableButtonEditProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  return (
    <>
      <Button 
        className="btn-icon" 
        type="info" 
        onClick={() => setModalIsOpen(true)} 
        to="#" 
        shape="circle"
        >
        <FeatherIcon icon="edit" size={16} />
      </Button>

      <Modal
        title="Editar"
        visible={modalIsOpen}
        onCancel={() => setModalIsOpen(false)}
        confirmLoading={true}
        footer={null}
        maskClosable={false}
        width={1200}
        style={{marginTop: -60}}
        bodyStyle={{padding: 0}}
      > 
        <Form 
          formType="put"
          proprietarioId={proprietarioId}
          initialFields={{
            bancoAgencia: data.bancoAgencia,
            comprovanteResidencia: data.comprovanteResidencia,
            idPessoa: String(data.idPessoa),
            bancoConta: data.bancoConta,
            idEmpresa: String(data.idEmpresa),
            idBanco: String(data.idBanco),
          
          

          }}
          setModalIsOpen={setModalIsOpen} 
          refetch={refetch} 
        />
      </Modal>
    </>
  );
}